import styled from 'styled-components';

export const ManualForm = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ManualFormLabel = styled.div`
  color: #3C3B3B;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Poppins-Bold;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  margin-top: 24px;
  margin-bottom: 5px;

  &:after {
    content: '*';
    color: #D40020;
  }
`;

export const ErrorMessage = styled.span`
  color: red;
  font-family: Poppins-Regular;
  font-size: 11px;
  font-style: normal;
  margin: 5px 5px;
`;

export const BlockingErrorMessage = styled.div`
  color: #D40020;
  background: #FFDEDE;
  border-radius: 4px;
  font-family: Poppins-Regular;
  font-size: 13px;
  font-style: normal;
  padding: 10px 12px;
  margin-top: 16px;
`;
